import GeoPoint from "@/models/Shared/GeoPoint";
import GeneralStatus from "@/models/Shared/GeneralStatus";

export default class CreateLocationRequest  {
    status: GeneralStatus = GeneralStatus.ActiveOrApproved;
	registeredName = '';  
    brandName = '';
    locationTypeId = '';
    rateCardId = '';
    emailAddress = '';
    phoneNumber = '';
    taxNumber = '';    
    registrationNumber = '';
    arrivalInstructions = '';
    website = '';
    biography = '';
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
}